import { MODAL_TYPES } from "../../utils/emitter";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useModalActions from "../../hooks/useModalActions";
import Game from "../../store/Game";
import General from "../../store/General";
import PersonalAccount from "../../store/PersonalAccount";
import useCookie from "../../hooks/useCookie";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import ROUTES from "../../utils/routes";

export default function useController() {
  const { removeCookie } = useCookie();
  const { removeUserData } = useCurrentUserData();
  const { navigateTo } = useCustomNavigate();
  const { closeModal } = useModalActions();

  const onExit = () => {
    PersonalAccount.setInitialState();
    General.setInitialState();
    Game.setInitialState();
    removeUserData();
    removeCookie("token");
    closeModal(MODAL_TYPES.EXIT);
    navigateTo(ROUTES.LANDING_PAGE);
  };
  return {
    onExit,
  };
}
